import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { emitDatadogError } from "@faire/web--source/common/datadog/rum";
import { isLocal } from "@faire/web--source/common/user-agent/isLocal";
import { isStaging } from "@faire/web--source/common/user-agent/isStaging";
var logException = function logException(level) {
  return function (error, options) {
    if (options !== null && options !== void 0 && options.serverOnly) {
      // TODO: FD-176705 - log exceptions without the use of globals.
      // (we can't `getGlobalProperty` from server components)
      return;
    }
    var optionsWithLevel = _objectSpread(_objectSpread({}, options !== null && options !== void 0 ? options : {}), {}, {
      level: level
    });
    // eslint-disable-next-line @faire-web/no-restricted-globals
    if (typeof window === "undefined") {
      import("@faire/web--source/common/serverLogging").then(function (_ref) {
        var log = _ref.default;
        if (level === "fatal" || level === "error") {
          log.error(error, optionsWithLevel);
        } else if (level === "warning") {
          log.warn(error, optionsWithLevel);
        } else {
          log.info(error, optionsWithLevel);
        }
      });
    } else {
      emitDatadogError(error, optionsWithLevel);
    }
  };
};
export var logFatal = logException("fatal");
export var logError = logException("error");
export var logWarning = logException("warning");
export var logInfo = logException("info");
export var logAssert = function logAssert(condition, message, options, reporter) {
  if (!condition) {
    var msg = "".concat(reporter ? "".concat(reporter, ": ") : "").concat(message);
    var error = new Error(msg);
    logError(error, options !== null && options !== void 0 ? options : {});
    if (isLocal() || isStaging()) {
      throw error;
    }
  }
};